export default __webpack_public_path__ + "static/media/cs-c001-Picture4.10dbff1e.png";